export const magnitudeFormKeys = {
  WEIGHT: "weight",
  LENGTH: "length",
  BREADTH: "breadth",
  HEIGHT: "height",
};
